import { RslReportChannel } from '../api/schema';

export const channelNames: Record<RslReportChannel['channelType'], string> = {
  combined: 'Total',
  in_store: 'In-Store',
  online: 'E-Commerce',
} as const;
